import React, { Component } from "react";
import { Div, Text, Image } from "atomize";
import AnimateLink from "../common/AnimateLink";

export default class MarketingBigButton extends Component {
  render() {
    const { link } = this.props;

    return (
      <Div textAlign="center" maxW="45rem" m="auto" className="marketing">
        <Div d={{ xs: "block", md: "none" }} m={{ b: "1.25rem" }}>
          <Image src="/images/trend-gold.svg" h="15px" w="auto" />
        </Div>
        <Text
          textSize={{ xs: "title2", md: "display4" }}
          textWeight="bold"
          className="big-text"
        >
          Ready to create custom content and generate buzz?
        </Text>
        <Div m={{ t: "2.5rem", b: "9.375rem" }}>
          <AnimateLink to={link}>
            <Div
              className="hero-btn"
              d="flex"
              m="auto"
              align="center"
              justify="center"
              textWeight="700"
              bg="primary"
              hoverBg="primary700"
              rounded="circle"
              shadow="primary"
              p="3.5rem 1rem 3.4rem"
              w="10.5rem"
              h="10.5rem"
            >
              <Text
                style={{ fontSize: "21px", lineHeight: "24px" }}
                fontFamily="secondary"
                textColor="black"
                textAlign="center"
                maxW="11rem"
              >
                Schedule a Demo
              </Text>
            </Div>
          </AnimateLink>
        </Div>
      </Div>
    );
  }
}
